// extracted by mini-css-extract-plugin
export var container = "_pg-0";
export var dotAnimation = "_pg-2";
export var dotsLoading = "_pg-1";